import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { getRegionSchedule, postRegionSchedule } from 'utils/api/admin';

const DAY_LABELS = ['월', '화', '수', '목', '금', '토', '일'];

const Schedule = () => {
  const [regions, setRegions] = useState([]);
  const [saveStatus, setSaveStatus] = useState('');

  useEffect(() => {
    fetchSchedule();
  }, []);

  const fetchSchedule = async () => {
    try {
      const res = await getRegionSchedule();
      setRegions(res.results);
    } catch (err) {
      console.error(err);
    }
  };

  const toggleDay = (idx, day) => {
    const updated = [...regions];
    const days = updated[idx].days || [];
    if (days.includes(day)) {
      updated[idx].days = days.filter((d) => d !== day);
    } else {
      updated[idx].days = [...days, day].sort();
    }
    setRegions(updated);
  };

  const toggleActive = (idx) => {
    const updated = [...regions];
    updated[idx].active = !updated[idx].active;
    setRegions(updated);
  };

  const handleSave = async () => {
    setSaveStatus('저장 중...');
    try {
      const payload = regions.map((r) => ({
        sido_name: r.sido_name,
        label: r.label || r.sido_name,
        days: r.days || [],
        active: !!r.active,
      }));
      await postRegionSchedule({ value: payload });
      setSaveStatus('저장 완료');
      setTimeout(() => setSaveStatus(''), 2000);
    } catch (err) {
      setSaveStatus('저장 실패');
    }
  };

  return (
    <Container>
      <TitleRow>
        <Title>크롤링 주기 설정</Title>
        <SaveRow>
          {saveStatus && <SaveStatus>{saveStatus}</SaveStatus>}
          <SaveBtn onClick={handleSave}>저장</SaveBtn>
        </SaveRow>
      </TitleRow>
      <Table>
        <thead>
          <tr>
            <Th>지역</Th>
            {DAY_LABELS.map((d, i) => (
              <Th key={i} style={{ textAlign: 'center', width: 50 }}>
                {d}
              </Th>
            ))}
            <Th style={{ textAlign: 'center', width: 60 }}>활성</Th>
          </tr>
        </thead>
        <tbody>
          {regions.map((r, idx) => (
            <tr key={r.sido_name}>
              <Td>{r.label || r.sido_name}</Td>
              {[0, 1, 2, 3, 4, 5, 6].map((day) => (
                <Td key={day} style={{ textAlign: 'center' }}>
                  <Checkbox
                    type="checkbox"
                    checked={(r.days || []).includes(day)}
                    onChange={() => toggleDay(idx, day)}
                  />
                </Td>
              ))}
              <Td style={{ textAlign: 'center' }}>
                <Toggle active={r.active} onClick={() => toggleActive(idx)}>
                  {r.active ? 'ON' : 'OFF'}
                </Toggle>
              </Td>
            </tr>
          ))}
        </tbody>
      </Table>
      <Note>
        요일: 월(0) ~ 일(6). Python weekday 기준. 저장 후 다음 크롤링부터
        적용됩니다.
      </Note>
    </Container>
  );
};

const Container = styled.div``;
const TitleRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
`;
const Title = styled.h1`
  font-size: 22px;
  font-weight: 700;
  color: #232d42;
`;
const SaveRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;
const SaveStatus = styled.span`
  font-size: 13px;
  color: #38a169;
`;
const SaveBtn = styled.button`
  padding: 8px 24px;
  background: #644ded;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  cursor: pointer;
  &:hover {
    background: #5338d4;
  }
`;
const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
`;
const Th = styled.th`
  text-align: left;
  padding: 12px 16px;
  font-size: 13px;
  font-weight: 600;
  color: #8f9bba;
  border-bottom: 1px solid #e4e4e4;
  background: #fafafa;
`;
const Td = styled.td`
  padding: 10px 16px;
  font-size: 14px;
  color: #232d42;
  border-bottom: 1px solid #f0f0f0;
`;
const Checkbox = styled.input`
  width: 18px;
  height: 18px;
  cursor: pointer;
  accent-color: #644ded;
`;
const Toggle = styled.span`
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  background: ${({ active }) => (active ? '#e6ffed' : '#f0f0f0')};
  color: ${({ active }) => (active ? '#38a169' : '#8f9bba')};
`;
const Note = styled.div`
  font-size: 12px;
  color: #8f9bba;
  margin-top: 12px;
`;

export default Schedule;
